var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"font-semibold text-gray-800",class:{ 'flex justify-between': _vm.optional }},[_vm._t("default"),_vm._v(" "),(_vm.optional)?_c('span',{staticClass:"font-thin italic"},[_vm._v("\n        (optionnel)\n    ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }